/*
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
 * @Date: 2020-12-28 17:39:08
 * @LastEditTime: 2021-01-25 18:11:46
 */
// 
const i18n = {
  'zh-CN': {
    province: '省',
    city: '市',
    area: '区',
    street: '街道',
    placeholder: '请选择地址',
    retry: '重试一次',
    loadFail: '加载失败，',
    dataLoading: '数据加载中',
    empty: '清空',
    noData: '无'
  },
  en: {
    province: 'Province',
    city: 'City',
    area: 'District',
    street: 'Street',
    placeholder: 'Please select the address',
    retry: 'Try again',
    loadFail: 'Loading failed,',
    dataLoading: 'Data loading',
    empty: 'Clear',
    noData: '无'
  },
  ja: {
    province: 'province',
    city: 'city',
    area: 'area',
    street: 'street',
    placeholder: 'Please select address',
    retry: 'Try again',
    loadFail: 'Failed to load,',
    dataLoading: 'Data loading',
    empty: 'empty',
    noData: 'No Data'
  }
}
export default i18n
